import { GenIcon } from '../helpers/IconBase.es.js';

const MinusSmallOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 16 16", fill: "none" },
    child: [
      {
        tag: "rect",
        attr: {
          width: "16",
          height: "16",
          rx: "4",
          fill: "#0200BC",
          fillOpacity: "0.05"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M11.3333 7.33313H4.66667C4.29848 7.33313 4 7.63161 4 7.9998C4 8.36799 4.29848 8.66647 4.66667 8.66647H11.3333C11.7015 8.66647 12 8.36799 12 7.9998C12 7.63161 11.7015 7.33313 11.3333 7.33313Z",
          fill: "#43464C"
        }
      }
    ]
  })(props);
};

export { MinusSmallOutlined };
